<div class="container">
  <ng-container *ngIf="mealsets$ | async as mealsets; else loading">
    <div class="menu-wrap">
      <div class="mealsets">
        <div class="tool-bar">
          <button (click)="goToMenu()" class="align-left" aria-label="Go back to the menu" title="Go back to the menu">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <button (click)="toggleOpen()" aria-label="Toggle All Meal Sets" title="Open All Menu Sets">
            <mat-icon *ngIf="!toggleAllOpen">add_circle_outline</mat-icon>
            <mat-icon *ngIf="toggleAllOpen">remove_circle_outline</mat-icon>
          </button>
          <button (click)="print()" aria-label="Print" title="Print">
            <mat-icon>print</mat-icon>
          </button>
        </div>
        <section *ngFor="let data of mealsets" [class.unpublished]="!data.published">
          <h2>{{data.name}}</h2>
          <app-mealset *ngFor="let i of data.mealSets; let x = index"
            attr.id="set-{{api.getId(i['@id'])}}"
            [id]="api.getId(i['@id'])"
            [image]="i.image"
            [title]="i.name"
            [tagline]="i.tagline"
            [open]="toggleAllOpen"
            [published]="i.published"
          >
          </app-mealset>
        </section>
      </div>
      <aside aria-label="Menu Appendix">
        <nav>
          <ul>
            <li *ngFor="let data of mealsets; let i = index">
              <span class="font-size-3">
                <button
                  attr.aria-controls="subnav-{{i}}"
                  [attr.aria-expanded]="data.open"
                  (click)="toggleMenu(i)"
                  >
                  <mat-icon *ngIf="!data.open">add_circle_outline</mat-icon>
                  <mat-icon *ngIf="data.open">remove_circle_outline</mat-icon>
                  {{data.name}}
                </button>
              </span>

              <ul id="subnav-{{i}}" [attr.aria-hidden]="!data.open">
                <li *ngFor="let d of data.mealSets; let x = index">
                  <a [routerLink]='"."' fragment="set-{{d['@id']}}">{{d.name}}</a>
              </ul>
            </li>
          </ul>
        </nav>
      </aside>
    </div>
  </ng-container>
  <ng-template #loading>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
    
  


